export default __webpack_public_path__ + "static/media/Frame.524f404e.webp";